import './TeamMember.css';

export const TeamMember = ({name,title}) => {
    return (
        <div className="team-member">
            <h4>{name}</h4>
            <span>{title}</span>
        </div>
    )
}